(function () {
  "use strict";

  var allowed = /^(gclid|gbraid|wbraid|fbclid|msclkid|utm_[a-z0-9_]+)$/i;

  function trackingParams() {
    var params = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (allowed.test(key)) params.set(key, value);
    });
    return params;
  }

  function carryTracking() {
    var params = trackingParams();
    var previewView = new URLSearchParams(window.location.search).get("view") === "fuelmate-pump";
    document.querySelectorAll('a[href^="/pages/fuelmate-pump-product"]').forEach(function (link) {
      var target = new URL(
        previewView ? window.location.pathname + "?view=fuelmate-pump-product" : link.getAttribute("href"),
        window.location.origin
      );
      params.forEach(function (value, key) { target.searchParams.set(key, value); });
      link.setAttribute("href", target.pathname + target.search + target.hash);
    });
  }

  function repairProtectedEmail() {
    document.querySelectorAll('a[href*="email-protection"], [data-cfemail]').forEach(function (node) {
      node.textContent = "support@primegradelabs.com";
      if (node.tagName === "A") node.setAttribute("href", "mailto:support@primegradelabs.com");
      node.removeAttribute("data-cfemail");
    });
    Array.prototype.forEach.call(document.querySelectorAll("a,span,div,p"), function (node) {
      if (!node.children.length && /^\s*\[?email protected\]?\s*$/i.test(node.textContent || "")) {
        node.textContent = "support@primegradelabs.com";
        if (node.tagName === "A") node.setAttribute("href", "mailto:support@primegradelabs.com");
      }
    });
  }

  function wireAccordions() {
    document.querySelectorAll('.question-line').forEach(function (question) {
      var parent = question.parentElement;
      var item = question.closest('.cursor-pointer') || parent;
      var scope = item && item.parentElement ? item.parentElement : parent;
      var answer = scope && scope.querySelector('.answer-line');
      if (!answer || question.__fmpFaq) return;
      question.__fmpFaq = true;
      var icon = question.querySelector('.question-icon');
      answer.hidden = true;
      answer.classList.remove('show');
      question.setAttribute('role', 'button');
      question.setAttribute('tabindex', '0');
      question.setAttribute('aria-expanded', 'false');
      function setOpen(open) {
        answer.hidden = !open;
        answer.classList.toggle('show', open);
        question.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (icon) icon.style.transform = open ? 'rotate(0deg)' : 'rotate(-45deg)';
      }
      function toggle(event) {
        if (event && event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
        if (event) event.preventDefault();
        setOpen(question.getAttribute('aria-expanded') !== 'true');
      }
      question.addEventListener('click', toggle);
      question.addEventListener('keydown', toggle);
    });
  }

  function wireProductAnchors() {
    document.querySelectorAll('a[href="#pgBundles"]').forEach(function (link) {
      link.setAttribute('href', '#pgBundles');
      link.addEventListener('click', function (event) {
        var bundles = document.getElementById('pgBundles');
        if (!bundles) return;
        event.preventDefault();
        bundles.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });
  }

  function restorePromotionAndCounter() {
    var promo = document.querySelector('.promotion8-left-content-slick');
    if (promo && !promo.textContent.trim()) {
      promo.innerHTML = '<div class="fmp-promo-message">#1 Bestselling Battery Powered Fuel Transfer Pump for Effortless, Clean &amp; Automatic Refueling</div>';
    }
    var counter = document.getElementById('comment18-title-1080541598996762626');
    if (counter && !counter.textContent.trim()) counter.textContent = '18,000';
  }

  function restoreFooterPolicies() {
    var footer = document.querySelector('.footer-content');
    if (!footer || footer.querySelector('.fmp-policy-links')) return;
    var logo = footer.querySelector('img.footer-logo');
    if (!logo) return;
    var policies = document.createElement('nav');
    policies.className = 'fmp-policy-links';
    policies.setAttribute('aria-label', 'Store policies');
    policies.style.cssText = 'display:flex;flex-wrap:wrap;justify-content:center;gap:7px;margin:0 0 14px;font-size:13px';
    policies.innerHTML =
      '<a href="https://primegradelabs.com/policies/shipping-policy">Shipping Policy</a><span>|</span>' +
      '<a href="https://primegradelabs.com/policies/refund-policy">Returns &amp; Refund</a><span>|</span>' +
      '<a href="https://primegradelabs.com/policies/privacy-policy">Privacy Policy &amp; Cookies Policy</a><span>|</span>' +
      '<a href="https://primegradelabs.com/policies/terms-of-service">Terms &amp; Conditions</a>';
    footer.insertBefore(policies, logo);
  }

  function restoreGallery() {
    var carousel = document.querySelector('.gallery5-carousel');
    if (!carousel || carousel.__fmpGallery) return;
    var slides = Array.prototype.slice.call(carousel.querySelectorAll('.slick-slide'));
    if (!slides.length) return;
    carousel.__fmpGallery = true;
    var index = 0;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, position) {
        var active = position === index;
        slide.classList.toggle('slick-active', active);
        slide.classList.toggle('slick-current', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
    var startX = null;
    carousel.addEventListener('pointerdown', function (event) {
      startX = event.clientX;
      if (carousel.setPointerCapture) carousel.setPointerCapture(event.pointerId);
    });
    carousel.addEventListener('pointerup', function (event) {
      if (startX === null) return;
      var delta = event.clientX - startX;
      startX = null;
      if (Math.abs(delta) > 20) show(index + (delta < 0 ? 1 : -1));
      else show(index + 1);
    });
    show(0);
  }

  function wireSectionNavigation() {
    var sectionMap = {Overview: 'overview', Features: 'features', Use: 'use', Reviews: 'reviews'};
    document.querySelectorAll('.header-menu, .header7-container-pc .cursor-pointer').forEach(function (item) {
      var label = (item.textContent || '').trim();
      var id = sectionMap[label];
      if (!id || item.__fmpNav) return;
      item.__fmpNav = true;
      item.addEventListener('click', function () {
        var section = document.getElementById(id);
        if (section) section.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });
  }

  function start() {
    carryTracking();
    repairProtectedEmail();
    wireAccordions();
    wireProductAnchors();
    restorePromotionAndCounter();
    restoreFooterPolicies();
    restoreGallery();
    wireSectionNavigation();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
